import React, { useState } from "react";
import { Button } from "../../../../../controls";
import {
  DriveFileMoveRounded,
  LocalPrintshopRounded,
  ReplayRounded,
} from "@mui/icons-material";
import PrintQuoteReceipt from "./PrintQuoteReceipt";
import { PrintDiv, ToFormData } from "../../../../../hooks/Method";
import { action, API, controller } from "../../../../../api/api";

const Header = ({ value, setQuotes, handleClose, handleContinuSale }) => {
  const [archiveLoading, setArchiveLoading] = useState(false);
  const handlePrint = () => {
    setTimeout(() => {
      PrintDiv("printQuoteReceipt");
    }, 500);
  };

  const handleArchive = () => {
    setArchiveLoading(true);
    const onComplete = (res) => {
      setArchiveLoading(false);
      if (res && res.status === 200) {
        setQuotes &&
          setQuotes((quotes) => [
            ...quotes.map((j) =>
              j.id === res.result.id ? { ...j, status: 3 } : j
            ),
          ]);
        handleClose && handleClose();
      } else console.error("Custome Error: ", res);
    };

    API(controller.QuoteSale + action.ArchiveQuote).post(
      ToFormData({
        id: value.id,
        date: new Date().toLocaleString(),
      }),
      onComplete
    );
  };

  return (
    <>
      <div className="d-none" id="printQuoteReceipt">
        {value && value.id && <PrintQuoteReceipt data={value} />}
      </div>
      <div className="flex gap-[10px] flex-wrap mr-[10px]">
        {value.status === 1 && (
          <>
            <Button
              onClick={() => handleContinuSale(value)}
              disabled={archiveLoading}
              variant="text"
              startIcon={<ReplayRounded />}
            >
              Continue Sale
            </Button>
            <Button
              loading={archiveLoading}
              onClick={handleArchive}
              variant="text"
              startIcon={<DriveFileMoveRounded />}
            >
              Archive
            </Button>
          </>
        )}
        <Button
          onClick={handlePrint}
          variant="text"
          startIcon={<LocalPrintshopRounded />}
        >
          Print Receipt
        </Button>
        {}
      </div>
    </>
  );
};

export default Header;
